export default "/_next/static/images/f7172607166cab685c22348f642d7fab.png";